import { useEffect, useState } from 'react';
import LocationDisclosureModal from './ui/LocationDisclosureModal';
import {
  LOCATION_DISCLOSURE_EVENT,
  _resolvePendingDisclosure,
} from '../services/locationGate';

/**
 * Single app-wide mount point for the location disclosure modal. Listens for
 * the `LOCATION_DISCLOSURE_EVENT` dispatched by `requestLocationWithDisclosure`
 * and resolves the pending promise when the user taps "Continue".
 *
 * Mounted once in App.tsx. Does not render anything unless a request is
 * pending.
 */
export default function LocationDisclosureHost() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(LOCATION_DISCLOSURE_EVENT, handler);
    return () => window.removeEventListener(LOCATION_DISCLOSURE_EVENT, handler);
  }, []);

  const handleContinue = () => {
    setOpen(false);
    _resolvePendingDisclosure();
  };

  return <LocationDisclosureModal open={open} onContinue={handleContinue} />;
}
